/*
 * Copyright 2024 The Kokabo Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */


class Address {

    constructor(value) {
        this.value = value;
    }

    isReversible() {
        // Empty addresses are treated as invalid; all routing tokens are reversible to support explicit reply routing.
        return !(this.value.length === 0);
    }

    inverse() {
        if (!this.isReversible()) {
            return InvalidAddress;
        }

        const tokens = [];
        let currentToken = "";

        const isSingleRuneAToken = (r) => {
            return r === '*' || r === '.' || r === '!' || r === ':';
        };

        const shouldReset = (r, token) => {
            if (isSingleRuneAToken(r)) {
                return true;
            }
            if (token.length > 0) {
                const ftr = token[0];
                // '-' is allowed inside an @uuid; outside that context it acts as a structural separator and must terminate the current token.
                if (ftr !== '@' && r === '-') {
                    return true;
                }
            }
            return false;
        };

        for (let i = 0; i < this.value.length; i++) {
            const r = this.value[i];
            const accumulator = currentToken;
            if (shouldReset(r, accumulator)) {
                if (currentToken.length > 0) {
                    tokens.push(currentToken);
                    currentToken = "";
                }
            }
            if (isSingleRuneAToken(r)) {
                tokens.push(r);
                continue;
            }
            currentToken += r;
        }
        if (currentToken.length > 0) {
            tokens.push(currentToken);
        }
        tokens.reverse();
        return new Address(tokens.join(''));
    }

    toString(){
        return this.value;
    }
}

const InvalidAddress =  new Address("INVALID_ADDRESS");
const BroadcastAddress = new Address("*");
const ExclusiveAddress =  new Address("!");
const ChildAddress =  new Address("0");
const LocalAddress =  new Address("-1");


export {Address, InvalidAddress, BroadcastAddress, ExclusiveAddress, ChildAddress, LocalAddress};